import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@sw/api-client';
import {
  getTalentExperiences,
  type GetTalentExperiencesParams,
} from './talentExperiencesApi';

export const TALENT_EXPERIENCES_QUERY_KEY = ['talent', 'experiences'] as const;

export function useTalentExperiences(params: GetTalentExperiencesParams) {
  return useQuery({
    queryKey: [
      ...TALENT_EXPERIENCES_QUERY_KEY,
      params.shortlistPublicKey,
      params.talentPublicKey,
    ],
    queryFn: () => getTalentExperiences(params),
    staleTime: 60_000,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status === 404) return false;
      return failureCount < 2;
    },
  });
}
